import { createFileRoute } from "@tanstack/react-router";
import { AuthLayout } from "#app/components/auth/auth-layout";
import { ResetPasswordForm } from "#app/components/auth/reset-password-form";

function ResetPasswordScreen() {
  return (
    <AuthLayout
      heading="Reset Password"
      subheading="Enter your new password below."
      footerText="Already have an account?"
      footerLinkText="Log in"
      footerLinkHref="/login"
    >
      <ResetPasswordForm />
    </AuthLayout>
  );
}

export const Route = createFileRoute("/(auth)/reset-password")({
  // The security page's "Set password" action emails this link to the signed-in
  // user, so the session that requested it is the one that opens it. Without
  // the opt-out the root navigator bounces that visitor into the app and the
  // reset token is never consumed.
  staticData: { allowAuthenticated: true },
  component: ResetPasswordScreen,
});
